import { Stack } from '@fluentui/react';

import type { ToastAction } from '@shared/lib/ui/components-alpha/useToast';

import { Button } from '../Button/Button';
import { buttonStylesGhost } from '../Button/Button.styles';

/**
 * Renders new-style toast `actions` ({ label, onClick }) as ghost buttons for the legacy
 * `MessageBar` UI, so a toast can carry action callbacks instead of an embedded ReactNode message.
 */
export const ToastActions = ({ actions }: { actions: ToastAction[] }) => (
  <Stack horizontal horizontalAlign="end" tokens={{ childrenGap: 8 }}>
    {actions.map((action) => (
      <Button key={action.label} onClick={action.onClick} styles={buttonStylesGhost}>
        {action.label}
      </Button>
    ))}
  </Stack>
);
